import { Input } from '../../../shared/ui'
import { Disclosure } from './Disclosure'

interface Props {
  value: string
  onChange: (value: string) => void
  open: boolean
  onToggle: () => void
}

/**
 * The sign-off's share of the comment: the trimmed text, only when it differs from what is stored.
 * A plain confirm therefore sends no `technicianComment` at all (the API leaves the column alone),
 * while an emptied field goes out as `""`, which the API stores as null.
 */
export function commentPatch(
  stored: string | null | undefined,
  draft: string,
): { technicianComment?: string } {
  const next = draft.trim()
  return next === (stored ?? '').trim() ? {} : { technicianComment: next }
}

/**
 * The optional technician comment on a sign-off. Plain state rather than react-hook-form: the
 * sheets carry no validated fields any more, so a form was pure ceremony.
 */
export function CommentDisclosure({ value, onChange, open, onToggle }: Props) {
  return (
    <Disclosure label="Kommentar" open={open} onToggle={onToggle}>
      <Input
        as="textarea"
        value={value}
        onChange={onChange}
        placeholder="Optionaler Hinweis für das Büro"
        inputClassName="!min-h-[80px]"
      />
    </Disclosure>
  )
}
